export const validationErrorsToDisplayText = (errors) => {
  if (!errors || !Array.isArray(errors)) {
    return undefined;
  }

  const displayErrors = {};

  errors.forEach((iError) => {
    if (!iError) {
      return;
    }

    const { property, constraints, children } = iError;

    if (constraints) {
      const constraintValues = Object.values(constraints);

      if (constraintValues.length) {
        const valuesToSet = constraintValues.map((i) => (`${ i }\n`));

        displayErrors[property] = valuesToSet
      }
    } else if (children?.length) {
      const childErrorsWithProp = [];

      children.forEach((child) => {
        const childProp = child.property || false;

        const nestedErrors = (child?.children?.length) ? child.children : child;

        const nestedErrorDisplayTest = validationErrorsToDisplayText(nestedErrors);

        if (childProp && !childErrorsWithProp[childProp]) {
          childErrorsWithProp[childProp] = nestedErrorDisplayTest;
        } else {
          childErrorsWithProp.push(nestedErrorDisplayTest);
        }
      });

      displayErrors[property] = childErrorsWithProp;
    }
  });

  return displayErrors;
}
